export default "__VITE_ASSET__vhLfkDAN__"